export interface SankeyOptions {
  showScenarios: boolean;
  showModels: boolean;
  showCategories: boolean;
  showCadMaterials: boolean;
  showCo2MaterialTypes: boolean;
  showSystems: boolean;
  showSubSystems: boolean;
  showAttributes: boolean;
  showEmptyNodes: boolean;
  showLayerTitles: boolean;
}

export enum SankeyOptionKeys {
  showScenarios = "showScenarios",
  showModels = "showModels",
  showCategories = "showCategories",
  showCadMaterials = "showCadMaterials",
  showCo2MaterialTypes = "showCo2MaterialTypes",
  showSystems = "showSystems",
  showSubSystems = "showSubSystems",
  showAttributes = "showAttributes",
  showEmptyNodes = "showEmptyNodes",
  showLayerTitles = "showLayerTitles",
}